import { Injectable } from '@angular/core';
import { map, mergeMap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Observable, EMPTY, of, forkJoin } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SocoHttpService } from '@soco/http';
import { SocoConfigurationService } from '@soco/configuration';
import { ApiResult } from '@soco/core';
import { url } from 'inspector';
import { string } from 'prop-types';


@Injectable()
export class AppCommonService {
        
    public appDataBaseUrl = '/AppData/';

    constructor(private http: SocoHttpService, private ngHttp: HttpClient, private config: SocoConfigurationService) { }

    getApplicationConfigs() {

        return this.http.get<any>({
            url: this.appDataBaseUrl + 'GetApplicationConfig'
        });
    }
}